import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { Leaf } from "lucide-react";

const fm = (n) => Math.round(n || 0).toLocaleString("en-US");

export const AvoidedCosts = ({ city }) => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/commons/treasury/avoided-costs`, { params: { city } }).then((r) => setD(r.data)).catch(() => setD(null)); }, [city]);
  if (!d) return null;
  return (
    <div className="qs-panel p-4 grid md:grid-cols-4 gap-4 items-center" data-testid="avoided-costs">
      <div>
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#00FF7F]"><Leaf className="h-4 w-4" /> Avoided fertilizer cost</div>
        <div className="font-mono text-3xl font-bold text-[#00FF7F] mt-1" data-testid="avoided-try">{fm(d.avoided_try)} <span className="text-sm text-slate-500">TRY</span></div>
        <div className="text-[10px] text-slate-500 font-mono">{fm(d.verified_avoided_try)} TRY on lab-verified scans · {d.co2e_avoided_t} t CO₂e</div>
      </div>
      <div className="md:col-span-2 text-xs text-slate-400 leading-relaxed">
        Variable-rate prescriptions from <b className="text-slate-200">{d.scans}</b> hyperspectral scan{d.scans === 1 ? "" : "s"} in {city} ({d.verified_scans} lab-verified) replace blanket {d.crop} fertilization. Every TRY the collective spends on <b className="text-[#F59E0B]">scan subsidies</b> ({fm(d.scan_subsidy_disbursed_try)} TRY so far) returns
        <b className="text-[#00FF7F]" data-testid="return-multiple"> {d.return_multiple != null ? `${d.return_multiple}×` : "—"}</b> in avoided input cost — this is the pool the levy feeds.
        {d.learned && <span className="block text-[10px] text-slate-500 mt-1">prescriptions corrected ×{d.learned.multiplier} from {d.learned.trials} strip trials</span>}
      </div>
      <div className="text-[10px] text-slate-500 space-y-0.5 font-mono" data-testid="avoided-rows">
        {d.rows.slice(0, 4).map((r) => <div key={r.scan_id} className="flex justify-between gap-2"><span className="truncate text-slate-400">{r.project}{r.live_scene ? " · S2" : ""}{r.verified ? " ✓" : ""}</span><span className="text-[#00FF7F]">{fm(r.saving_try)}</span></div>)}
      </div>
    </div>
  );
};
